<template>
  <v-app>
    <component :is="layout" />
  </v-app>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();
const layout = ref();

watch(
  () => route.meta.layout,
  (newLayout) => {
    layout.value = newLayout;
  }
);
</script>

<style lang="scss">
#app {
  font-family: Helvetica, Avenir, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
